import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "../../../store";

export const selectTabTitleUpdateIntervalId = createSelector(
  (state: AppState) => state.chat.settings.tabTitleUpdateIntervalId,
  (tabTitleUpdateIntervalId) => tabTitleUpdateIntervalId
);
